import React from 'react'
import TextFieldUniversal from '../../../../validate/form/text/TextFieldUniversal'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyOrdersQuery } from '../../../../../store/supplyOrderSlice'

const SupplyOrdersFilterQuery = () => {

    const query = useSelector(state => state.supplyOrder.supplyOrders.query)
    const dispatch = useDispatch()

    const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            // setValueForm(e)
            dispatch(setSupplyOrdersQuery(e))
            setValue(e)
        }}
        // setValidate={setValidate}
        label={'Пошук'} 
        placeholder={'Введіть для пошуку'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={query}
        required={false}		
    />
  )
}

export default SupplyOrdersFilterQuery